import styled from 'styled-components';
import { motion } from 'framer-motion';

const motionIn = {
  duration: 1,
  ease: [0.6, -0.05, 0.01, 0.99]
};
const motionOut = {
  duration: 0.2
};
const motionTitle = {
  initial: {
    x: -40,
    opacity: 0 
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      delay: 0.1,
      ...motionIn
    }
  },
  exit: {
    x: -20,
    opacity: 0,
    transition: {
      ...motionOut
    }
  }
};
const Head = styled(motion.header)`
  padding: 0 0 20px 0;
`;
const Title = styled.h1`
  font-weight: normal;
  font-size: 40px;
  line-height: 40px;
  margin: 0;
`;
const Teaser = styled.h2`
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  margin: 5px 0 0 0;
`;

type HeaderProps = {
  title: string,
  teaser?: string
}

function Header({ title, teaser }: HeaderProps) {
  return (
    <Head initial="initial" animate="animate" exit="exit" variants={motionTitle}>
      <Title>{title}</Title>
      {teaser && <Teaser>{teaser}</Teaser>}
    </Head>
  );
}

export default Header;